import React from "react";

/**
 * ─── Avatar ───────────────────────────────────────────────────────────────
 * Person / org avatar with initials + gradient fallback.
 *
 * Props
 *   name      string    — used to derive initials + testId
 *   src       string    — image url
 *   size      "xs" | "sm" | "md" | "lg" | "xl"
 *   square    boolean   — rounded rectangle instead of circle
 *   testId
 */
function initialsOf(name = "") {
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map(p => p[0]?.toUpperCase() || "").join("") || "?";
}

export default function Avatar({ name = "", src, size = "md", square = false, testId }) {
  const cn = ["ds-avatar", `ds-avatar--${size}`, square && "ds-avatar--square"].filter(Boolean).join(" ");
  return (
    <span className={cn} data-testid={testId} aria-label={name || undefined} role="img">
      {src ? <img src={src} alt="" /> : initialsOf(name)}
    </span>
  );
}

/** Overlapping avatars for a compact group ("+n" overflow handled by caller). */
export function AvatarGroup({ children, testId }) {
  return <span className="ds-avatar-group" data-testid={testId}>{children}</span>;
}
